import React from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid, removeToken } from '../utils/auth';

export default function ProtectedRoute({ children }) {
  if (!isTokenValid()) {
    removeToken();
    return <Navigate to="/login" replace />;
  }
  return children;
}
